module.exports = __webpack_public_path__ + "img/mon_64.f9938073.png";